import settings from "@/plugins/api/factories/Settings";

export const state = {
  settings: null,
  phone: null,
  newPhone: null,
  agreement: false,
  subscription: null,
  newIndicationPhone: null,
  indicationPhone: {
    phone: null,
    uid: null
  }
};

export const mutations = {
  STORE_SETTINGS(state, settings) {
    state.settings = settings;
  },
  STORE_PHONE(state, phone) {
    state.phone = phone;
  },
  STORE_INDICATION_PHONE(state, phone) {
    state.indicationPhone.phone = phone
  },
  STORE_INDICATION_UID(state, uid) {
    state.indicationPhone.uid = uid
  },
  UPDATE_LANGUAGE(state, language) {
    if (state.settings !== null) {
      state.settings.language = language;
    }
  },
  UPDATE_NAME(state, name) {
    state.settings.name = name;
  },
  UPDATE_SURNAME(state, surname) {
    state.settings.surname = surname;
  },
  UPDATE_EMAIL(state, email) {
    state.settings.email = email;
  },
  UPDATE_PHONE(state, phone) {
    state.newPhone = phone;
  },
  UPDATE_INDICATION_PHONE(state, phone) {
    state.newIndicationPhone = phone;
  },
  AGREEMENT(state, agreement) {
    state.agreement = agreement;
  },
  GET_SUBSCRIPTION(state, subscription){
    state.subscription = subscription;
  },
};

export const actions = {
  async getPhone({ commit }) {
    await settings.getPhone((response) => {
      commit("STORE_PHONE", response);
    });
  },
  async getIndicationPhone({ commit }, uid) {
    await settings.getIndicationPhone(uid, (response) => {
      commit("STORE_INDICATION_PHONE", response.phone);
      commit("UPDATE_INDICATION_PHONE", response.phone);
    });
  },
  async getSettings({ commit }) {
    settings.getSettings((response) => {
      commit("STORE_SETTINGS", response.user);
      commit("GET_SUBSCRIPTION", response.subscription);
    });
  },
  async storeSettings({ state, commit }) {
    return await settings.storeSettings(state.settings, (response) => {
        commit("Auth/SET_USER_STATUS", response.status_sub, { root: true });
    });
  },
  async storePhone({ state }) {
    return await settings.storePhone(state.newPhone);
  },
  async storeIndicationPhone({ state }) {
    return await settings.storeIndicationPhone(state.indicationPhone);
  },
  async putLanguage({ commit }, language) {
    commit("UPDATE_LANGUAGE", language);
    return await settings.putLanguage(language);
  },
};
